module.exports = {"542233100":"浪卡子镇","542233101":"打隆镇","542233200":"张达乡","542233201":"伦布雪乡","542233202":"多却乡","542233203":"普玛江塘乡","542233204":"阿扎乡","542233205":"卡龙乡","542233206":"白地乡","542233207":"卡热乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542233.json
// module id = 2550
// module chunks = 0